import { useState } from "react";

const ARENA_BACKGROUND_URL = "/assets/arena/arena-dungeon-v2.webp";

export function ArenaBackdrop() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className={`arena-backdrop${loaded ? " arena-backdrop--loaded" : ""}`}
      data-testid="arena-backdrop"
      data-loaded={loaded}
      aria-hidden="true"
    >
      <img
        src={ARENA_BACKGROUND_URL}
        alt=""
        decoding="async"
        fetchPriority="high"
        draggable={false}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
